import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Header from '../../../../Components/Header';
import { IN_PROGRESS, SUCCESS_MESSAGE, ERROR, LOGOUT } from '../../../../Constants';
import * as UserAction from '../../../../Store/Actions/User';
import { clearAccessToken } from '../../../../Utils';
import { FooterMenu } from '../../../../Components/FooterMenu';
import { CreditDeposit } from '../../../../Components/Admin/Users/CreditDeposit';
import { UserActions } from '../../../../Store/Actions';

export const AgentDepositCredit = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const submit = async (payload, callback) => {
    dispatch({ type: IN_PROGRESS });
    UserAction.creditTransfers(payload)
      .then((response) => {
        if (response.data.success) {
          UserActions.getUserBalanceAndMessages();
          UserActions.getUsers();
          callback();
          dispatch({
            type: SUCCESS_MESSAGE,
            data: {
              message: t('credit.transferSuccess', {amount: payload.amount}),
            },
          });
          navigate('../Transactions');
        } else {
          dispatch({
            type: ERROR,
            data: { error_msg: response.data.message },
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 403) {
            clearAccessToken();
            dispatch({
              type: LOGOUT,
            });
          } else
            dispatch({
              type: ERROR,
              data: { error_msg: error.response.data.message },
            });
        } else {
          dispatch({
            type: ERROR,
            data: { error_msg: error.message.toString() },
          });
        }
      });
  };

  return (
    <div className='agent_layout'>
      <Header name={t('userAction.deposit')} agentMenu={true} />
      <CreditDeposit submit={submit} />
      <FooterMenu />
    </div>
  );
};
